import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React, {MouseEvent} from 'react';

import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import copyToClipboard from 'util/clipboard/copyToClipboard';

import getPublicLink from './getPublicLink';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  system: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  operationPath: any;
}

export default function CopyPublicLink(props: Props): JSX.Element {
  const {operationPath, system} = props;

  function handleCopyPublicLink(e: MouseEvent): void {
    e.stopPropagation();
    copyToClipboard(getPublicLink(operationPath, system), {showToastOnSuccess: true});
  }

  return (
    <Tooltip container="body" placement={TooltipPlacement.TOP} title="Copy Public Link">
      <BenchlingIcon
        className={classNames('u-gray-light', css(styles.icon))}
        icon="copy"
        onClick={handleCopyPublicLink}
      />
    </Tooltip>
  );
}

const styles = StyleSheet.create({
  icon: {
    marginRight: '14px',
    cursor: 'pointer',
    fontSize: '12px',
    ':focus': {
      outline: 0,
    },
  },
});
